import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCommissionByMovement } from './CommissionByMovement.services';

export function useQuestReportCommissionByMovement() {
  return useMutation(getQuestReportCommissionByMovement, {
    onSuccess() {
      notification.success({
        message:
          'O relatório de comissão por movimentação foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
